module.exports = __webpack_public_path__ + "img/LUB00151.6008f7d9.png";